import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WhatsappButton = () => {

  return (
    <div id="whatsapp-button" className="whatsapp-button">
      <a href={`https://wa.me/+966558896965?`} target="_blank" rel="noreferrer">
        <WhatsAppIcon sx={{ cursor: 'pointer', fill:  '#fff', fontSize: 28 }} alt="WhatsApp" />
      </a>
    </div>
  );
};

export default WhatsappButton;
